import { imageExtensions, previewExtensions } from '../config/fileTab';

export const getFileExtension = (file) => {
  const extension = file?.extension || (file?.name?.includes('.') ? file.name.slice(file.name.lastIndexOf('.')) : '');

  if (!extension) return '';

  return (extension.startsWith('.') ? extension : `.${extension}`).toLowerCase();
};

export const isImageFile = (file) => imageExtensions.includes(getFileExtension(file));

export const isPreviewable = (file) => previewExtensions.includes(getFileExtension(file));

export const getAttachmentUrl = (path) => {
  if (!path) return null;
  if (/^(https?:|blob:|data:)/i.test(path)) return path;

  const apiUrl = new URL(process.env.REACT_APP_API_URL || window.location.origin, window.location.origin);
  const normalizedPath = path.replace(/\\/g, '/').replace(/^\/+/, '');
  const apiBaseUrl = apiUrl.toString().replace(/\/+$/, '');
  return `${apiBaseUrl}/${normalizedPath}`;
};
